import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useRouter } from 'next/router';

export const useHeaderAnimation = () => {
  const { route } = useRouter();
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const isCheckout = false;
    const ctx = gsap.context(() => {
      const animTrigger = {
        trigger: 'header',
        start: 1,
        end: 1,
        toggleActions: 'play none reverse none',
        pin: false,
      };
      const animDuration = 0.2;

      ScrollTrigger.matchMedia({
        '(min-width: 1171px)': () => {
          gsap
            .timeline({ scrollTrigger: animTrigger })
            .to('header', { duration: animDuration, paddingBlock: 6 });
          gsap.set('#app:not(.checkout) .header', { clearProps: 'all' });
          gsap.set('header', { clearProps: 'all' });
        },
        '(max-width: 1170px)': () => {
          gsap.set('.header', { clearProps: 'all' });
          gsap.set('header', { clearProps: 'all' });
        },
      });
    });
    if (isCheckout) {
      ctx.revert();
    }
    return () => ctx.revert();
  }, [route]);
};

export default useHeaderAnimation;
